

export const convertIntoLakh = (amount) => {
    if (amount !== "" && amount !== undefined) {
        if (amount >= 100000 && amount < 10000000) {
            const lakhAmount = amount / 100000;
            return `${Number.isInteger(lakhAmount) ? lakhAmount.toFixed(0) : lakhAmount.toFixed(1)} Lakh`;
        } else if (amount >= 10000000) {
            const croreAmount = amount / 10000000;
            return `${Number.isInteger(croreAmount) ? croreAmount.toFixed(0) : croreAmount.toFixed(1)} Cr`;
        } else if (amount >= 1000) {
            const thousandAmount = amount / 1000;
            return `${Number.isInteger(thousandAmount) ? thousandAmount.toFixed(0) : thousandAmount.toFixed(2)} Thousand`;
        }
        return amount;
    }
};

export const CommaSeprator = (input) => {
    if (input !== null && input !== undefined) {

        let value = input;
        let rupee = value.toString();
        let newRupee = rupee.substring(rupee.length - 3);
        let other = rupee.substring(0, rupee.length - 3);
        if (other !== '')
            newRupee = ',' + newRupee;
        //console.log(newRupee);
        let formatedValue = other.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + newRupee;
        return formatedValue;
    }
};

export const CountYear = (yearVal) => {
    let today = new Date();
    today = new Date(today.setFullYear(today.getFullYear() + parseInt(yearVal)));
    let year = today.getFullYear();
    return year;
};

/*export const getAge = (birthdate) => {
    let today = new Date();
    let birthDate = new Date(birthdate);
    let age = today.getFullYear() - birthDate.getFullYear();
    let month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    console.log("get agearr")
    return age;
};
*/

export const TermLifeLoaderBox = [{
    id: 1,
    Image: "https://i.ibb.co/r7qJ7vp/Canera-Hsbc-Obc.png",
},
{
    id: 2,
    Image: "https://i.ibb.co/ZXrmq05/Aegon.png",
}, {
    id: 3,
    Image: "https://i.ibb.co/jrZkV4P/Future.png",
}, {
    id: 4,
    Image: "https://i.ibb.co/CB94MGj/primica.png",
}, {
    id: 5,
    Image: "https://i.ibb.co/44kgJsp/Kotak.png",
}, {
    id: 6,
    Image: "https://i.ibb.co/4jcfmRF/IciciPru.png",
},
];
export const calculateAge = (age) => {
  
        console.log("isAge")
        let CoverTillAge = []
        for (let Age = age+5; Age <= 100; Age++) {
            CoverTillAge.push({
                value: Age,
                label: Age + " years"
            })

        }
        return CoverTillAge
}

export const AnnualIncomeArr = () => {
    let AnnualIncome = []
    for (let Amt = 2; Amt < 30; Amt++) {
        AnnualIncome.push({
            value: Amt * 100000,
            label: Amt + " Lakhs"
        })

    }
    return AnnualIncome
}

export const PayDuration = () => {
    let PayTerm = []
    for (let Yrr = 1; Yrr <= 10; Yrr++) {
        PayTerm.push({
            value: 5 * Yrr,
            label: 5 * Yrr + " Years"
        })

    }
    return PayTerm
}
/*const ShowSideError = (props) => {
    return (
        <div className="ShowSideError">
            <span>{props.errorMSG}</span>
        </div>
    )
}
export default ShowSideError*/


